import React, { type FunctionComponent } from 'react'
import { Breadcrumb, Breadcrumbs } from '@retailer-platform/shared-components'
import AppHeader from 'legacy/components/AppHeader'
import { useDashMessages } from 'intl/intl.hooks'
import { useScopedPathname } from 'utils/routing/url.hooks'

interface Props {
  pageType: 'create' | 'update' | 'details' | 'bannerTypeSelector'
  placementName?: string
}

export const HeroBannerBreadcrumbs: FunctionComponent<Props> = ({ pageType, placementName }) => {
  const messages = useDashMessages({
    homeLink: 'merchandising.hero-banners.title',
    bannerTypeSelector: 'merchandising.hero-banners.page.create.typeSelect.title',
    create: 'merchandising.hero-banners.page.create.title',
    update: 'merchandising.hero-banners.page.update.title',
  })

  return (
    <AppHeader
      title={
        <Breadcrumbs>
          <Breadcrumb path={useScopedPathname('merchandising-hero-banners-list')}>
            {messages.homeLink}
          </Breadcrumb>
          {messages[pageType] && <Breadcrumb>{messages[pageType]}</Breadcrumb>}
          {placementName && <Breadcrumb>{placementName}</Breadcrumb>}
        </Breadcrumbs>
      }
    />
  )
}
